import React, { useState } from 'react';
import { connect } from 'react-redux'
import { openPopup, closePopup, clearPopup } from '../actions/popup';
import { openSnackbar, closeSnackbar } from '../actions/snackbar';
import api from '../api/index'

function AdminReport({ openPopup, closePopup, openSnackbar, closeSnackbar }) {
  const [theme, setTheme] = useState(null)
  const [name, setName] = useState(null)
  const [email, setEmail] = useState(null)
  const [comment, setComment] = useState(null)
  const textError = <p className="auth-label-required">Это обязательное поле</p>
  const sign = <span style={{ color: '#fe2c2c' }}>*</span>
  const send = e => {
    e.preventDefault()
    new Promise((resolve) => {
      if (/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(email)) return resolve()
      else throw new Error("Неверный формат электронной почты")
    }).then(() => {
      if (name.length <= 100) return true
      else throw new Error("Имя не может содержать более 100 символов")
    }).then(() => {
      // openSnackbar(`Ожидайте открытия почтового клиента...`, 'success')
      // setTimeout(() => {
      //   window.location.href = `mailto:filippov7799@gmail.com?subject=${theme}&body=${comment}%0D%0A%0D%0A...%0D%0AС уважением, ${name}%0D%0AEmail: ${email}`
      //   //window.open(`mailto:filippov7799@gmail.com?subject=${theme}&body=${comment}%0D%0A%0D%0A...%0D%0AС уважением, ${name}%0D%0AEmail: ${email}`)
      // }, 700)
      const body = {
        to: email,
        subject: `Уведомление о поступлении нового обращения пользователя портала hcvf.ru (${theme})`,
        body: `Тема обращения: "${theme}"\nИмя заявителя: ${name}\nE-mail заявителя: ${email}\nКомментарий: ${comment}`
      }
      
      openSnackbar('Отправка сообщения...', 'success')
      document.getElementById('iframeAuth').contentWindow.postMessage({ name: 'adm_report', body }, "*")
    }).catch(error => openSnackbar(error.message, "error"))
  }

  const onload = () => {
    window.addEventListener('message', message2, false)
  }

  const message2 = (e) => {
    if (e.origin === `https://hcvf.citorus.ru:8889`) {
      // console.log(e)
      // if (e.data.name === 'adm_report') {
      //   const data = JSON.parse(e.data)
      //   if (data.error === true) {
      //     openSnackbar(data.msg, "error")
      //     return;
      //   } else if (data.error === false) {
      //     openSnackbar(data.msg, "success")
      //   }
      // }
    }
  }

  return (
    <form className='auth-editForm' onSubmit={send}>
      <iframe id="iframeAuth" onLoad={onload} name="iframeAuth" src="https://hcvf.citorus.ru:8889/public/hcvf_auth/" style={{ position: 'absolute', width: 0, height: 0, border: 'none' }}></iframe>
      <label className="auth-label clr-white fs-14">Тема обращения{sign}:</label>
      <input required={true} className={`auth-input big ${theme === '' ? 'error' : ''}`} onChange={e => setTheme(e.target.value)} autoComplete='off' type="text" />
      {theme === '' && textError}

      <label className="auth-label clr-white fs-14 mt-8">Ваше имя{sign}:</label>
      <input required={true} className={`auth-input big ${name === '' ? 'error' : ''}`} onChange={e => setName(e.target.value)} autoComplete='off' />
      {name === '' && textError}

      <label className="auth-label clr-white fs-14 mt-8">E-mail{sign}:</label>
      <input required={true} className={`auth-input big ${email === '' ? 'error' : ''}`} onChange={e => setEmail(e.target.value)} autoComplete='off' />
      {email === '' && textError}

      <label className="auth-label clr-white fs-14 mt-8">Комментарий{sign}:</label>
      <textarea required={true} className={`auth-textarea ${comment === '' ? 'error' : ''}`} onChange={e => setComment(e.target.value)} autoComplete='off' style={{ width: '252px', height: '168px' }} />
      {comment === '' && textError}

      <p className="auth-label-required mt-4">*Эти поля обязательны</p>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button className="auth-button mt-16" type='submit'>Отправить</button>
      </div>

    </form>
  )
}

export default connect(null, { openPopup, closePopup, openSnackbar, closeSnackbar })(AdminReport)